(function () {
    'use strict';

    angular.module('swif.framework')
    .factory('swifAlerter', swifAlerter);

    function swifAlerter($interval, $location, dataService, settingsService, userService, actionService, swifFilterService) {
        'ngInject';
        var settings = settingsService;
        var service = {};
        var alerter = {filters:[]};
        service.loadAlertFilters = function () {
            service.stopAlertFilters();
            var filter = {};
            var userId = userService.getAuthenticatedUser().uid;
            dataService.sortOn(filter, 'model_id', 'ASC');
            dataService.addFilter(filter, 'user_id', '=', userId);
            dataService.addFilter(filter, 'is_alert', '=', true);
            dataService.get('filter', undefined, filter)
            .then(function (filters) {
                alerter.filters = filters;
                //lets go to interval this one !!!
                _.forEach(filters, function (filter){
                    if (!filter.stop) {
                        filter.stop = $interval(function () {
                            service.queryFilter(filter);
                        }, 600000); // 1000 * 60 * 10
                    }
                    service.queryFilter(filter);
                });
            });
        };

        service.stopAlertFilters = function () {
            if (alerter.filters) {
                _.forEach(alerter.filters, function (filter) {
                    if (angular.isDefined(filter.stop)) {
                        $interval.cancel(filter.stop);
                        filter.stop = undefined;
                    }
                });
            }
        };

        service.updateCount = function () {
            alerter.count_level = {};
            alerter.count_total = 0;
            var new_results = false;
            _.forEach(alerter.filters, function(filter) {
                if (filter.new_results) {
                    alerter.count_total += filter.count_new_results;
                    if (filter.alert_level) {
                        if (!alerter.count_level[filter.alert_level]) {
                            alerter.count_level[filter.alert_level] = filter.count_new_results;
                        } else {
                            alerter.count_level[filter.alert_level] += filter.count_new_results;
                        }
                    }
                    new_results = new_results || filter.new_results;
                }
            });
            alerter.new_results = new_results;
        };

        service._getContentType = function (filter) {
            var ret;
            var ctxContentType = filter.ui_context ? filter.ui_context.contentType : null;
            if (ctxContentType) {
                ret = settings.getContentType(ctxContentType);
            } else {
                ret = settings.getContentTypeFromModel(filter.model_id);
            }
            return ret;
        };

        service.queryFilter = function (filter) {
            var _filter = {};
            _filter.fields = ['id', 'name'];
            dataService.setFilters(_filter, swifFilterService.parseDomain(filter));
            var last_results_json = filter.last_results_json;
            var contentType = service._getContentType(filter);
            return dataService._get(contentType.id, undefined, _filter, false)
            .then(function (result) {
                filter.last_results_json = JSON.stringify(result.ids);
                var old_ids = JSON.parse(last_results_json);
                var has_new_results = false;
                filter.new_results_ids = [];
                _.forEach(result.ids, function (id) {
                    if (!_.contains(old_ids, id)) {
                        filter.new_results = true;
                        filter.new_results_ids.push(id);
                        has_new_results = true;
                    }
                });
                filter.count_new_results = filter.new_results_ids.length;
                if (!has_new_results) {
                    filter.new_results = false;
                }
                filter.result_names = [];
                filter.count_results = result.length;
                _.forEach(result.records, function (data) {
                    if (_.contains(filter.new_results_ids, data.id)) {
                        filter.result_names.push(data.name);
                    }
                });
                if (!_.isEmpty(filter.result_names)) {
                    filter.tooltip = '<ul style="text-align:left;"><li>';
                    filter.tooltip += _(filter.result_names).join('</li><li>');
                    filter.tooltip += '</li></ul>';
                }
                //notify the user
                service.updateCount();
            });
        };

        service.applyAlertFilter = function (filter) {
            var convertFromString = function(domain) {
                var ret = domain.replace(/'/g, '"');
                return JSON.parse(ret);
            }
            var getProjectId = function(filterDomain) {
                var projectId = undefined;
                if (typeof filterDomain === 'string') {
                    filterDomain = swifFilterService.parseDomain(filter);
                }
                filterDomain.forEach((function(item) {
                    if (item[0] === 'project_id') {
                        projectId = item[2];
                    }
                }).bind(this));
                return projectId;
            }
            var checkIsControlOrContract = function(filterDomain) {
                // looking for ["project_id.is_control", "=", true]
                var isControlOrContract = false;
                if (typeof filterDomain === 'string') {
                    filterDomain = swifFilterService.parseDomain(filter);
                }
                filterDomain.forEach((function (item) {
                    if (item[0] === 'project_id.is_control' || item[0] === 'project_id.is_contract')  {
                        if (item[2] === true) {
                            isControlOrContract = true;
                        }
                    }
                }).bind(this));
                return isControlOrContract;
            }
            var projectId = getProjectId(filter.domain);
            var contentType = service._getContentType(filter);
            var isControlOrContract = checkIsControlOrContract(filter.domain);
            var cid = contentType.alert.collection_id;
            // dirty fix because contracts in patrimoine and parcauto have the same content type... :'(
            if (contentType.model==='project.project'
                && _.contains(filter.domain, "['service_id.is_parcauto', '=', 'true']")){
                // so we select a fake content type for parc auto contract alert
                var action = actionService.getActionById('parcauto_contract', 'views', 'table');
                if (action) {
                    var _filter = {};
                    dataService.addExtraFilter(_filter, 'is_parcauto', 'service_id.is_parcauto', '=', true);
                    var domain = swifFilterService.parseDomain(filter);
                    // we hadded is_parcauto in extra filter so we remove it from filters domain
                    domain.pop();
                    dataService.setFilters(_filter, domain);
                    swifFilterService.loadFilteredCollection(cid, action, _filter);
                    manageNewResults(filter);
                }
            } else if (contentType.model === 'project.task' && isControlOrContract) {
                var prefix = location.hash.split('/')[1];
                var path = `/${prefix}/contracts/table_view`;
                var search = `c:contracts={"domain":[["id","=",${projectId}]]}`;
                $location.path(path);
                $location.search(search);
            }
             else {
                var action = actionService.getActionById(contentType.id, 'views', 'table');
                if (action) {
                    var _filter = {};
                    var domain = swifFilterService.parseDomain(filter);
                    dataService.setFilters(_filter, domain);
                    swifFilterService.loadFilteredCollection(cid, action, _filter);
                    manageNewResults(filter);
                }
            }
        };

        function manageNewResults(filter) {
            if (filter.new_results) {
                filter.new_results = false;
                dataService.save('filter', filter.id, {
                    last_results_json: filter.last_results_json
                }).then(function () {
                    service.updateCount();
                });
            }
        };

        service.getAlerterObject = function () {
            return alerter;
        };

        return service;
    }


})();
